export const ncRowKey = (row) => `${row.numero}:${row.riga}`;

export function createNcListLoader(work) {
    const pending = new Map();
    return (params) => {
        const key = JSON.stringify(params);
        if (!pending.has(key)) {
            const request = Promise.resolve()
                .then(() =>
                    work.get("/arts/nc/", params, false, null, {
                        ignoreGlobalErrorStatuses: [undefined, 400, 403, 503],
                    })
                )
                .finally(() => pending.delete(key));
            pending.set(key, request);
        }
        return pending.get(key);
    };
}

export function ncStage(row) {
    if (row.da_compilare) return "Da compilare";
    return row["8d_disponibile"] ? "8D disponibile" : "8D da completare";
}

export function legacyNcRedirect(to) {
    return {
        name: "qualita-riepilogo-nc",
        query: { ...to.query, status_8d: "pending", risolte: "no" },
        hash: to.hash,
    };
}

export async function markNcMaterialManaged(work, rows) {
    const succeeded = [];
    const failed = [];
    for (const row of rows) {
        try {
            const response = await work.post(
                `/arts/nc/${row.articolo}/`,
                {
                    action: "material",
                    numero: row.numero,
                    riga: row.riga,
                    risolta: true,
                },
                true
            );
            if (!response || response.data.stato_materiale !== "Materiale gestito") {
                throw new Error("Esito non confermato");
            }
            succeeded.push(ncRowKey(row));
        } catch (error) {
            failed.push(ncRowKey(row));
        }
    }
    return { succeeded, failed };
}
